import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

type ReactionUser = {
  id: string;
  name: string;
  role: string;
  avatarUrl?: string;
};

interface ReactionsModalProps {
  isOpen: boolean;
  title: string;
  items: ReactionUser[];
  isLoading?: boolean;
  onClose: () => void;
}

const ReactionsModal: React.FC<ReactionsModalProps> = ({ isOpen, title, items, isLoading, onClose }) => {
  if (!isOpen) return null;

  return (
    <>
      <div className="fixed inset-0 bg-black/50 z-[1000]" onClick={onClose} />
      <div className="fixed inset-0 z-[1010] flex items-center justify-center p-4">
        <div className="bg-card rounded-lg shadow-xl w-full max-w-md border border-border max-h-[80vh] flex flex-col">
          <div className="flex items-center justify-between p-4 border-b border-border">
            <div className="flex items-center gap-2">
              <Icon name="Users" size={18} className="text-muted-foreground" />
              <h2 className="text-base font-semibold text-foreground">{title}</h2>
            </div>
            <Button variant="ghost" size="sm" onClick={onClose} iconName="X" />
          </div>

          <div className="p-4 overflow-auto">
            {isLoading ? (
              <div className="flex items-center gap-2 text-sm text-muted-foreground">
                <Icon name="Loader2" size={16} className="animate-spin" />
                <span>Se încarcă…</span>
              </div>
            ) : items.length === 0 ? (
              <div className="text-sm text-muted-foreground">Încă nu există reacții.</div>
            ) : (
              <div className="space-y-3">
                {items.map((u) => (
                  <div key={u.id} className="flex items-center gap-3">
                    {u.avatarUrl ? (
                      <Image src={u.avatarUrl} alt={`Avatar ${u.name}`} className="w-9 h-9 rounded-full object-cover" />
                    ) : (
                      <div className="flex items-center justify-center w-9 h-9 rounded-full bg-muted text-foreground text-sm font-semibold">
                        {(u.name || 'U').charAt(0).toUpperCase()}
                      </div>
                    )}
                    <div className="min-w-0">
                      <div className="text-sm font-medium text-foreground truncate">{u.name}</div>
                      <div className="text-xs text-muted-foreground">{u.role}</div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ReactionsModal;

